import e from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import u from "./iconfont.es5471.js";
const f = {
  display: "block"
}, E = ({ size: t = 16, useVw: n, useRem: c, color: a, withColor: l, removeClassName: i, disableSSR: m, style: o, ...d }) => {
  const p = o ? { ...f, ...o } : f;
  return /* @__PURE__ */ e.createElement(u, { disableSSR: m }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "youtube-24px", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 24 24", width: n ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (c ? "rem" : "px"), height: n ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (c ? "rem" : "px"), className: i ? "" : "iconpark-icon", style: p, fill: "none", ...d }, /* @__PURE__ */ e.createElement(
    "g",
    {
      clipPath: "url(#1258ee__a)"
    },
    /* @__PURE__ */ e.createElement(
      "g",
      {
        clipPath: "url(#1258ee__b)"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          fill: l ? r(a, 0, "currentColor") : "currentColor",
          datafollowfill: l ? r(a, 0, "currentColor") : "currentColor",
          d: "m20.727 3.518-1.593-.16a71.788 71.788 0 0 0-14.335 0l-1.527.16c-.91.1-1.75.527-2.354 1.197a3.538 3.538 0 0 0-.919 2.427v8.716a3.538 3.538 0 0 0 .919 2.427 3.72 3.72 0 0 0 2.354 1.197l1.593.16a71.78 71.78 0 0 0 14.334 0l1.528-.16c.91-.1 1.75-.527 2.354-1.197.605-.67.933-1.535.919-2.427V7.142a3.538 3.538 0 0 0-.919-2.427 3.72 3.72 0 0 0-2.354-1.197Zm-5.455 8.641-4.243 2.763a.836.836 0 0 1-1.09-.278.783.783 0 0 1-.121-.38V8.736c0-.145.04-.287.117-.41a.81.81 0 0 1 .318-.293.836.836 0 0 1 .841.044l4.244 2.763c.112.072.205.17.269.284a.77.77 0 0 1-.27 1.034h-.065Z"
        }
      )
    )
  ), /* @__PURE__ */ e.createElement(
    "defs",
    null
  ), /* @__PURE__ */ e.createElement(
    "clipPath",
    {
      id: "1258ee__a"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fill: l ? r(a, 1, "#fff") : "#fff",
        d: "M0 0h24v24H0z"
      }
    )
  ), /* @__PURE__ */ e.createElement(
    "clipPath",
    {
      id: "1258ee__b"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        transform: "translate(-.001)",
        fill: l ? r(a, 2, "#fff") : "#fff",
        d: "M0 0h25.617v24H0z"
      }
    )
  )));
}, v = E;
export {
  v as default
};
